import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { FacebookDisplayCreative, ICallToActionType } from '@feathr/blackbox';
import { CallToActionTypes } from '@feathr/blackbox';
import { Input, Textarea, UniversalSelect } from '@feathr/components';

interface IMetaFieldsProps {
  creative: FacebookDisplayCreative;
}

function MetaFields({ creative }: Readonly<IMetaFieldsProps>): JSX.Element {
  const { t } = useTranslation();

  function handleCallToAction({ id }: ICallToActionType): void {
    creative.set({ call_to_action_type: id });
  }

  return (
    <>
      <Textarea
        attribute={'message'}
        helpText={t('Meta recommends 125 characters or less. Longer text may be truncated.')}
        label={t('Primary text')}
        maxLength={1000}
        model={creative}
        showCounter={true}
      />

      <Input
        attribute={'caption'}
        helpText={t(
          'Should go to the same domain as your destination URL. Must be 25 characters or less.',
        )}
        label={t('Display link')}
        maxLength={25}
        model={creative}
        showCounter={true}
        type={'text'}
      />

      <Input
        attribute={'description'}
        helpText={t('Meta recommends 27 characters or less.')}
        label={t('Title')}
        maxLength={100}
        model={creative}
        showCounter={true}
        type={'text'}
      />

      <UniversalSelect<ICallToActionType>
        helpText={t('Show a button or link that represents the action you want people to take')}
        label={t('Call to action')}
        menuPlacement={'top'}
        name={'call_to_action'}
        onSelectSingle={handleCallToAction}
        options={CallToActionTypes}
        placeholder={t('Select an option')}
        value={CallToActionTypes.find(
          (option) => option.id === creative.get('call_to_action_type'),
        )}
      />
    </>
  );
}

export default observer(MetaFields);
